<template>

    <div class="course p-3 px-lg-4 mb-3 d-md-flex align-items-center" :class="{'finished': isFinished(courseSchedule)}">
        <div class="course-info flex-fill">
            <div class="title mb-1">
                <a :href="courseSchedule.link" @click.prevent="selectCourseSchedule(courseSchedule)"
                   class="course-name">{{ courseSchedule.course.name }}</a>
                <span class="price" v-if="courseSchedule.price > 0">${{
                        courseSchedule.price
                    }}</span>
            </div>
            <div class="params mb-1">
                <span class="param">
                    <i class="fas fa-clock"></i>
                    {{ courseSchedule.from | dateFormat('h:mma') }} -
                    {{ courseSchedule.till | dateFormat('h:mma') }}
                </span>
                <span class="param">
                    <a :href="courseSchedule.trainer.link"
                       class="trainer-name">{{ courseSchedule.trainer.name }}</a>
                </span>
                <span class="param" v-if="courseSchedule.location">
                    <i class="fas fa-map-marker-alt"></i> {{ courseSchedule.location }}
                </span>
                <span class="param text-color-orange" v-if="courseSchedule.is_favorite">
                    <i class="fas fa-star text-color-orange"></i> favorite
                </span>
                <span v-for="order in courseSchedule.guest_orders">
                    <span class="param" >
                    <span v-if="order.course_order">
                        <span v-if="courseSchedule.is_finished">
                            <i class="fas fa-calendar-check"></i> took by {{ order.user.name }}
                        </span>
                        <span v-else>
                            <i class="far fa-calendar-alt"></i> scheduled by {{ order.user.name }}
                        </span>
                    </span>
                    </span>
                </span>
            </div>
            <div class="short_description">
                <span v-if="courseSchedule.course.short_description">
                    {{ courseSchedule.course.short_description }}
                </span>
                <a :href="courseSchedule.link" class="details" @click.prevent="selectCourseSchedule(courseSchedule)">view details</a>
            </div>
        </div>

        <div class="course-actions my-3 mb-2" v-if="!courseSchedule.is_finished">
            <button v-if="hasOrders(courseSchedule)"
                    class="btn btn-success btn-book ordered text-nowrap"
                    @click.prevent="selectCourseSchedule(courseSchedule)">
                <i class="fas fa-check-double" v-if="getOrders(courseSchedule).length > 1"></i>
                <i class="fas fa-check" v-else></i>
                Booked
            </button>

            <button v-else-if="hasWaits(courseSchedule)"
                    class="btn btn-success btn-book ordered text-nowrap"
                    @click.prevent="selectCourseSchedule(courseSchedule)">
                <i class="fas fa-check-double" v-if="getOrders(courseSchedule).length > 1"></i>
                <i class="fas fa-check" v-else></i>
                Wait Listed
            </button>

            <div v-else-if="courseSchedule.is_booking_required === false"
                 class="text-nowrap">
                  <span class="text-muted">
                   No reservation required
                  </span>
            </div>

            <button v-else-if="isBookable(courseSchedule)"
                    class="btn btn-success btn-book text-nowrap"
                    @click.prevent="selectCourseSchedule(courseSchedule)">
                Book now
            </button>

            <button v-else-if="isWaitable(courseSchedule)"
                    class="btn btn-info btn-book text-nowrap"
                    @click.prevent="selectCourseSchedule(courseSchedule)">
                Wait List
            </button>

            <button v-else-if="!courseSchedule.is_available"
                    class="btn btn-secondary btn-book text-nowrap order-disabled"
                    @click.prevent="selectCourseSchedule(courseSchedule)">
                Not available
            </button>

            <button v-else
                    class="btn btn-secondary btn-book text-nowrap order-disabled"
                    @click.prevent="selectCourseSchedule(courseSchedule)">
                Conflict
            </button>

        </div>
        <div class="course-actions my-3 mb-2 d-none" v-else>
            <button class="btn btn-danger text-nowrap order-past">
                Already happened
            </button>
        </div>
        <div class="clearfix"></div>

    </div>
</template>


<script>

export default {
    props: {
        courseSchedule: Object
    },
    data() {
        return {};
    },
    mounted() {
    },
    methods: {
        selectCourseSchedule: function () {
            this.$emit('select-course-schedule', this.courseSchedule)
        },
        isFinished: function (courseSchedule) {
            return courseSchedule.is_finished;
        },
        getOrders: function () {
            let orders = [];
            for (let i = 0; i < this.courseSchedule.guest_orders.length; i++) {
                if (this.courseSchedule.guest_orders[i].course_order) {
                    orders.push(this.courseSchedule.guest_orders[i].course_order);
                }
            }

            return orders;
        },
        getWaits: function () {
            return this.courseSchedule.waits;
        },
        hasOrders: function () {
            let orders = this.getOrders();

            return orders.length > 0;
        },
        hasWaits: function () {
            let waits = this.getWaits();

            return waits.length > 0;
        },
        isBookable: function () {
            //console.log(this.courseSchedule);
            if (!this.courseSchedule.is_available) {
                //console.log('not available');
                //console.log(this.courseSchedule.course.name + ' is not available');
                return false;
            }
            if (this.courseSchedule.available_places_count < 1) {
                //console.log(this.courseSchedule.course.name + ' has no available places');
                return false;
            }
            for (let i = 0; i < this.courseSchedule.guest_orders.length; i++) {
                if (this.courseSchedule.guest_orders[i].is_bookable) {
                    return true;
                }
            }

            return false;
        },
        isWaitable: function () {
            // if (!this.courseSchedule.is_available) {
            //     return false;
            // }
            // if (this.courseSchedule.available_places_count < 1) {
            //     return false;
            // }

            for (let i = 0; i < this.courseSchedule.guest_orders.length; i++) {
                if (this.courseSchedule.guest_orders[i].is_waitable) {
                    return true;
                }
            }

            return false;
        },

    },
    filters: {
        dateFormat: function (date, format) {
            return moment(date).format(format);
        }
    },
    computed: {}
}
</script>
